import { render, staticRenderFns } from "./UnitFeeForm.vue?vue&type=template&id=4986a582&scoped=true&"
import script from "./UnitFeeForm.vue?vue&type=script&lang=js&"
export * from "./UnitFeeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4986a582",
  null
  
)

export default component.exports